import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";

export default class ActualCompDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        temp: this.props.dataItem[this.props.field],        
    };
  }
  componentDidMount = () => {
    
    try {
      let element = document.getElementsByClassName("k-dateinput")[0];
      if (element) {
        element.addEventListener("keydown", (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  handleChange = (e) => {    
    this.props.onChange({
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
  };
    
  handleEditCell = () => {
    if(this.props.dataItem.isOpen==="Open" || this.props.dataItem.isOpen===true){
    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId=dataItem.userId;
    const riskOwnerId=this.props.riskDetails?this.props.riskDetails.userId:null;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
     
      return (
        <td>
           <DatePicker
            format="dd-MMM-yyyy"
            // formatPlaceholder="Snapchat11"
            defaultValue={dataValue}
            onChange={this.handleChange.bind(this)}
            defaultShow={true}
            max={new Date()}
          />
        </td>
      );
    } else {      
      
      if((loginUserId===ownerId||loginUserId===riskOwnerId)&&this.props.dataItem.isOpen===true){
        return (
          <td onClick={this.handleEditCell}>
            {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
          </td>
          )
      }else{
          return this.props.dataItem.role == "View Only"||this.props.dataItem.role == "Standard User"||this.props.dataItem.isOpen == false  ? (
            <td>
              {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
            </td>
          ) : (
            <td onClick={this.handleEditCell}>
              {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
            </td>
          );
      }
    }
  }
}
